// styles
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getPriceConceptsAndTotalPrices } from 'utils/order';
import LiteralCurrency from 'components/LiteralCurrency';
import SoFormCandidateBlockDetailsPriceBreakdownItemConcept from './SoFormCandidateBlockDetailsPriceBreakdownItemConcept';
import SoFormCandidateBlockDetailsPriceBreakdownTotalPriceDescription from './SoFormCandidateBlockDetailsPriceBreakdownTotalPriceDescription';
import extrasConstants from 'utils/extras/constants/index';
import { useSelector } from 'react-redux';
import { selectors as settingsSelectors } from 'state/settings';

const SoFormCandidateBlockDetailsPriceBreakdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 16px 0px;
  gap: 30px;
  background: var(--white);
  border-radius: 0px 0px 4px 4px;
`;

const SoFormCandidateBlockDetailsPriceBreakdownContainerItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  /* Inside auto layout */

  /* flex-grow: 1; */
  /* border: 1px solid red; */
`;

const SoFormCandidateBlockDetailsPriceBreakdownItem = styled.div`
  /* Frame 142 */

  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 0px 16px;

  /* width: 568px; */
  /* height: 40px; */

  /* grey / 200 */

  border-bottom: 1px solid #e2e8ee;
  /* border-bottom: 1px solid red; */
`;

const SoFormCandidateBlockDetailsPriceBreakdownItemPrice = styled.div`
  /* 00,00 € */

  width: 100px;
  height: 24px;

  /* 16px/regular

Shipper App Default
*/
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  text-align: right;

  /* grey / 700 */

  color: #54708c;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
`;

const SoFormCandidateBlockDetailsPriceBreakdownItemTotalPrice = styled.div`
  /* 94,00 € */

  width: 100px;
  min-height: 32px;

  /* 24px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  /* identical to box height, or 133% */

  text-align: right;

  /* grey / 800 */

  color: #3b4f63;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
`;

const PriceBreakdownHeading = styled.div`
  height: 24px;

  /* 20px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height, or 120% */

  /* grey / 700 */

  color: #54708c;
`;

const TotalPriceContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const TotalPriceWithNoTaxes = styled.div`
  display: flex;
  /* border: 5px solid black; */
`;

const TotalPriceWithTaxes = styled.div`
  /* position: absolute; */
  /* width: 190.31px; */
  height: 24px;
  /* left: 385.69px; */
  /* top: 415px; */

  /* 16px/regular

Shipper App Default
*/
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  text-align: right;

  /* grey / 700 */

  color: #54708c;
`;

const SoFormCandidateBlockDetailsPriceBreakdown = ({
  quote,
  className,
  isSummary = false,
}) => {
  const { t } = useTranslation('Quote');
  const { t: catalogT } = useTranslation('Catalog');
  const pricesAndConcepts = getPriceConceptsAndTotalPrices({
    quote,
    t,
  });
  const concepts = pricesAndConcepts.concepts;
  const totalPrices = pricesAndConcepts.totalPrices;

  const extrasInQuote = quote.shipments_extras || {};

  const hasHandlingExtrasInQuote = (extrasInQuote[0] || []).some((_, i) =>
    extrasConstants.HANDLING_EXTRAS.includes(
      (extrasInQuote[0][i] || {}).concept
    )
  );
  const countrySettings = useSelector(settingsSelectors.getCountrySettings);
  const isSpainCountry = countrySettings.country === 'ES';
  const orderExtras = quote.extras || [];
  const hasHandlingExtrasInDetail = orderExtras.some((r) =>
    [
      extrasConstants.HANDLING_LOADING,
      extrasConstants.HANDLING_UNLOADING,
    ].includes(r)
  );

  const isHandlingIncluded =
    isSpainCountry && (hasHandlingExtrasInQuote || hasHandlingExtrasInDetail);

  return (
    <div className={className}>
      <SoFormCandidateBlockDetailsPriceBreakdownContainer>
        <SoFormCandidateBlockDetailsPriceBreakdownContainerItems>
          {isSummary && (
            <PriceBreakdownHeading>
              {catalogT('price.details_and_price')}
            </PriceBreakdownHeading>
          )}
          {concepts.map((concept, index) => {
            const conceptQuantity = parseFloat(concept.conceptQuantity);
            return (
              <SoFormCandidateBlockDetailsPriceBreakdownItem
                key={concept.concept}
              >
                <SoFormCandidateBlockDetailsPriceBreakdownItemConcept
                  concept={concept}
                  index={index}
                  isHandlingIncluded={isHandlingIncluded}
                />
                <SoFormCandidateBlockDetailsPriceBreakdownItemPrice>
                  <LiteralCurrency
                    value={conceptQuantity}
                    strikethrough={concept.strikethrough}
                  />
                </SoFormCandidateBlockDetailsPriceBreakdownItemPrice>
              </SoFormCandidateBlockDetailsPriceBreakdownItem>
            );
          })}
          {totalPrices.map((totalPrice) => {
            const netPrice = parseFloat(totalPrice.netPrice);
            const grossFullPrice = parseFloat(totalPrice.fullPrice);
            return (
              <SoFormCandidateBlockDetailsPriceBreakdownItem
                key={totalPrice.title}
              >
                <TotalPriceContainer>
                  <TotalPriceWithNoTaxes>
                    <SoFormCandidateBlockDetailsPriceBreakdownTotalPriceDescription
                      isSummary={isSummary}
                    />
                    <SoFormCandidateBlockDetailsPriceBreakdownItemTotalPrice>
                      <LiteralCurrency value={netPrice} />
                    </SoFormCandidateBlockDetailsPriceBreakdownItemTotalPrice>
                  </TotalPriceWithNoTaxes>
                  {isSummary && (
                    <TotalPriceWithTaxes>
                      <LiteralCurrency value={grossFullPrice} />{' '}
                      {catalogT('price.vat_included')}
                    </TotalPriceWithTaxes>
                  )}
                </TotalPriceContainer>
              </SoFormCandidateBlockDetailsPriceBreakdownItem>
            );
          })}
        </SoFormCandidateBlockDetailsPriceBreakdownContainerItems>
      </SoFormCandidateBlockDetailsPriceBreakdownContainer>
    </div>
  );
};

export default styled(SoFormCandidateBlockDetailsPriceBreakdown)``;
